<template>
  <a
    :href="link"
    target="_blank"
    class="btn box text-gray-700 disabled:opacity-50 flex items-center"
  >
    <PrinterIcon class="w-4 h-4 mr-2 hidden md:block" />
    {{ props.title }}
  </a>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'btn-printer',
  props: {
    title: {
      type: String,
      default: () => 'พิมพ์'
    },
    module: {
      type: String,
      required: true
    },
    docId: {
      type: [Number, String]
    }
  },
  setup(props) {
    const link = computed(() => {
      return `${process.env.VUE_APP_API_PRINT}/pdf/${props.module}/print?docId=${props.docId}`
    })
    return { props, link }
  }
})
</script>

<style scoped></style>
